import { render, staticRenderFns } from "./_contact.vue?vue&type=template&id=ffb29cf4&scoped=true&"
import script from "./_contact.vue?vue&type=script&lang=js&"
export * from "./_contact.vue?vue&type=script&lang=js&"
import style0 from "./_contact.vue?vue&type=style&index=0&id=ffb29cf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffb29cf4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AccountFranchisorLayout: require('/home/circleci/repo/components/account-franchisor/AccountFranchisorLayout.vue').default})
